import { RELATION_HAS_PART } from '@backstage/catalog-model';
import { EntityRelatedEntitiesGridItem } from './EntityRelatedEntitiesGridItem';
import { EntityTable } from '@backstage/plugin-catalog-react';
import { EntityGridItemProps } from './EntityGridItemProps';

export const HasDomainsGridItem = (props: EntityGridItemProps) => {
  return (
    <EntityRelatedEntitiesGridItem
      {...props}
      relationFilter={{
        type: RELATION_HAS_PART,
        kind: 'Domain',
      }}
      title={props.title ?? 'Has domains'}
      columns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'domain' }),
        EntityTable.columns.createOwnerColumn(),
      ]}
      lgColumns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'domain' }),
        EntityTable.columns.createOwnerColumn(),
        EntityTable.columns.createMetadataDescriptionColumn(),
      ]}
    />
  );
};
